import { Button } from 'components/curo-components/common/Button';
import { ModalContentWrapper, ModalOverlay } from 'components/curo-components/common/Modal';
import ModalButtonsWrapper from 'components/curo-components/common/ModalButtonsWrapper';
import Title from 'components/curo-components/common/Title';
import Typography from 'components/curo-components/common/Typography';

import styles from './AcceptMarketingMessagesModal.module.scss';

interface IAcceptMarketingMessagesModalProps {
  onClose: () => void;
  handleAccept: (value: boolean) => void;
}

const MODAL_TITLE = 'Please confirm before proceeding';

const AcceptMarketingMessagesModal = ({
  onClose,
  handleAccept,
}: IAcceptMarketingMessagesModalProps) => {
  return (
    <ModalOverlay onClose={onClose}>
      <ModalContentWrapper onClose={onClose} wrapperClassName={styles.modalContentWrapper}>
        <Title type="h3">{MODAL_TITLE}</Title>
        <Typography type="primary" weight="normal">
          By clicking ACCEPT below, you expressly consent that Heights Finance Corporation may call
          or send you marketing and promotional messages regarding our products, including text
          messages and calls made using an automatic telephone dialing system or prerecorded or
          artificial voice messages to the number I provided. Consent is not a condition of
          purchase. Reply STOP to opt out of text messaging. Standard rates apply.
        </Typography>
        <ModalButtonsWrapper position="flex-start">
          <Button kind="primary" size="form" onClick={() => handleAccept(true)}>
            Accept
          </Button>
          <Button kind="secondary" size="form" onClick={() => handleAccept(false)}>
            Decline
          </Button>
        </ModalButtonsWrapper>
      </ModalContentWrapper>
    </ModalOverlay>
  );
};

export default AcceptMarketingMessagesModal;
